// extracted by mini-css-extract-plugin
export default {"menuButton":"MenuButton-menuButton-Jl5Je","isDisabled":"MenuButton-isDisabled-x0tG4"};